import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorage } from 'src/app/enums/local-storage-key.enum';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.css']
})
export class PaymentSuccessComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private localStorage: LocalStorageService
  ) { }

  ngOnInit(): void {
    const orderID = localStorage.getItem(LocalStorage.PAY_ORDER);
    const paymentForm = localStorage.getItem(LocalStorage.PAYMENT_IN);
    const previewOrder = this.localStorage.get(LocalStorage.go_back_url);
    const isSuccess = this.route.snapshot.data.success;
    if (paymentForm == 'form' && !isSuccess) {
      if (previewOrder === 'preview') {
        this.localStorage.delete(LocalStorage.go_back_url);
        this.router.navigate(['/order', 'edit'], { queryParams: { id: orderID, redirect: 'purchase' } })
        .then(() => {
          this.localStorage.delete(LocalStorage.PAY_ORDER);
          this.localStorage.delete(LocalStorage.PAYMENT_IN);
        });
      } else {
        this.router.navigate(['/order', 'edit'], { queryParams: { id: orderID, redirect: 'purchase', payment: '0' } })
        .then(() => {
          this.localStorage.delete(LocalStorage.PAY_ORDER);
          this.localStorage.delete(LocalStorage.PAYMENT_IN);
        });

      }
      return;
    }
    this.router.navigate(['/order', 'view'], { queryParams: { id: orderID, payment: isSuccess ? '1' : '0' } })
    .then(() => {
      this.localStorage.delete(LocalStorage.PAY_ORDER);
      this.localStorage.delete(LocalStorage.PAYMENT_IN);
    });
  }

  ngOnDestroy(): void {
    this.localStorage.delete(LocalStorage.go_back_url);
    this.localStorage.delete(LocalStorage.payment_data);

  }

}
